import { render, staticRenderFns } from "./EmpresasTablaActions.vue?vue&type=template&id=04569dc7&scoped=true"
import script from "./EmpresasTablaActions.vue?vue&type=script&lang=js"
export * from "./EmpresasTablaActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04569dc7",
  null
  
)

export default component.exports